<ng-container *ngIf="postData$ | async as postData; else loader">
  <mat-card-title>
    <h3 class="my-2 display-6">{{ postData?.title }}</h3></mat-card-title
  >
  <mat-card-content>
    <div
      style="text-align: center"
      class="view hm-zoom z-depth-2"
      style="cursor: pointer"
    >
      <img
        *ngIf="postData.imageUrl"
        style="margin: auto"
        [src]="postData.imageUrl"
        [alt]="postData.title"
        width="100%"
        class="image-fluid rounded"
      />
    </div>
  </mat-card-content>
  <mat-card-subtitle class="my-4">
    Last Updated On :
    <i class="fas fa-calendar" aria-hidden="true"></i>
    {{ postData?.updatedDate | date: "longDate" }}
    <br />
    Author :
    <i class="fas fa-user" aria-hidden="true"></i>
    {{ postData?.author | titlecase }}
  </mat-card-subtitle>
  <mat-divider></mat-divider>

  <mat-card-content class="py-3 align-items-center align-content-center">
    <!-- <div class="text-align-para" [innerHTML]="postData?.content"></div> -->
    <ckeditor
      name="myckeditor"
      [config]="ckeConfig"
      [(ngModel)]="postData.content"
      #myckeditor="ngModel"
      debounce="500"
      [disabled]="true"
      [editor]="Editor"
    ></ckeditor>
    <div style="text-align: center">
      <app-video style="margin: auto" [videoId]="postData?.videoId"></app-video>
    </div>

    <mat-divider></mat-divider>
  </mat-card-content>
</ng-container>
<ng-template #loader>
  <div class="d-flex justify-content-center">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>

<app-social-share></app-social-share>

<mat-divider></mat-divider>
<app-comments [blogId]="postId"></app-comments>
<app-scroller></app-scroller>
